import React from "react";
import { Box } from "@mui/material";

const logos = [
  { name: "AWS", src: "/logo/Amazon_Web_Services_Logo.svg" },
  { name: "Microsoft", src: "/logo/Microsoft_logo.svg" },
  { name: "Cisco", src: "/logo/Cisco.png" },
  { name: "Azure", src: "/logo/Azure.png" },
  { name: "Red Hat", src: "/logo/Redhat.png" },
  { name: "VMware", src: "/logo/VMware.png" },
  { name: "CompTIA", src: "/logo/CompTIA.png" },
  { name: "Kubernetes", src: "/logo/Kubernetes.png" },
  { name: "Linux", src: "/logo/linux.png" },
  { name: "PMP", src: "/logo/PMP.png" },
  // { name: "PowerBI", src: "/logo/PowerBI.png" },

  { name: "Steria", src: "/logo/steria.jpeg" },
  { name: "TCS", src: "/logo/tcs.png" },
  { name: "Wipro", src: "/logo/Wipro.png" },
  { name: "Siemens", src: "/logo/siemens.jpg" },
  { name: "ARINC", src: "/logo/ARINC.png" },
  { name: "Tech Mahindra", src: "/logo/TechMahindra.png" },
  { name: "Ericsson", src: "/logo/Ericsson.jpg" },
  { name: "Infosys", src: "/logo/Infosys.png" },
  { name: "Infotech", src: "/logo/infotech.png" },
  { name: "Accenture", src: "/logo/Accenture.png" },
  { name: "Convergys", src: "/logo/Convergys.png" },
  { name: "HCL", src: "/logo/HCL.png" },
  { name: "IBM", src: "/logo/IBM.png" },
  { name: "HP", src: "/logo/HP.png" },
];

export default function LogoMarquee() {
  const doubled = [...logos, ...logos];
  return (
    <Box sx={{ overflow: "hidden", py: 1 }}>
      <Box
        sx={{
          display: "flex",
          width: "max-content",
          gap: 1.5,
          animation: "marquee 28s linear infinite",
          "@keyframes marquee": {
            from: { transform: "translateX(0)" },
            to: { transform: "translateX(-50%)" },
          },
        }}
      >
        {doubled.map((logo, i) => (
          <Box
            key={`${logo.name}-${i}`}
            sx={{
              display: "flex", alignItems: "center", gap: 1.5,
              bgcolor: "white", border: "1px solid rgba(0,0,0,0.08)",
              borderRadius: 999, px: 2.5, py: 1.5,
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
              minWidth: "max-content",
            }}
          >
            <Box component="img" src={logo.src} alt={logo.name} sx={{ height: 24, width: "auto", objectFit: "contain" }} />
            <Box sx={{ fontSize: 13, fontWeight: 600, color: "text.primary" }}>{logo.name}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}